import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import SearchSelect from "../../../../components/private/searchselect";

const UpdateInformacionGeneral = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const { authFetch } = useContext(AuthContext);

  // ======================================
  // STATES
  // ======================================

  const [loading, setLoading] = useState(true);

  const [programs, setPrograms] = useState([]);

  const [formData, setFormData] = useState({

    id: "",

    programa: "",

    contrato_convenio: "",

    tipo_cobertura: "",

    contratante: "",

    objeto: "",

    lugar_ejecucion: "",

    cobertura: "",

    fecha_inicio: "",

    fecha_fin: "",

    valor_contrato_antes_iva: "",

    plazo_pago: ""

  });

  const [error, setError] = useState("");

  const [success, setSuccess] = useState("");

  // ======================================
  // CARGAR INFO GENERAL
  // ======================================

  useEffect(() => {

    const loadInfo = async () => {

      try {

        const res = await authFetch(
          `${ENDPOINTS.getById_informacion_general}?id=${id}`
        );

        console.log(res);

        if (res.success) {

          const info = res.data;

          setFormData({

            id: info.id ?? "",

            programa: String(
              info.id_programa ?? ""
            ),

            contrato_convenio:
              info.contrato_convenio ?? "",

            tipo_cobertura:
              info.tipo_cobertura ?? "",

            contratante:
              info.contratante ?? "",

            objeto:
              info.objeto ?? "",

            lugar_ejecucion:
              info.lugar_ejecucion ?? "",

            cobertura:
              info.cobertura ?? "",

            fecha_inicio:
              info.fecha_inicio
                ? info.fecha_inicio.substring(0, 10)
                : "",

            fecha_fin:
              info.fecha_fin
                ? info.fecha_fin.substring(0, 10)
                : "",

            valor_contrato_antes_iva:
              info.valor_contrato_antes_iva ?? "",

            plazo_pago:
              info.plazo_pago ?? ""

          });

        }

      } catch (error) {

        console.error(error);

        setError(
          "Error cargando información general"
        );

      }

      setLoading(false);

    };

    loadInfo();

  }, [id, authFetch]);

  // ======================================
  // CARGAR PROGRAMAS
  // ======================================

  useEffect(() => {

    const loadPrograms = async () => {

      try {

        const res = await authFetch(
          ENDPOINTS.getProgramAssignment
        );

        if (res.success) {

          setPrograms(res.data);

        }

      } catch (error) {

        console.error(error);

      }

    };

    loadPrograms();

  }, [authFetch]);

  // ======================================
  // INPUTS
  // ======================================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  // ======================================
  // OPTIONS PROGRAMAS
  // ======================================

  const programOptions = programs.map((p) => ({

    value: String(p.id),

    label: `${p.program_name} - ${p.area_name}`

  }));

  // ======================================
  // SUBMIT
  // ======================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setError("");

    setSuccess("");

    // =========================
    // VALIDACIONES
    // =========================

    if (!formData.programa) {

      setError(
        "Debe seleccionar el programa"
      );

      return;

    }

    if (!formData.contrato_convenio) {

      setError(
        "Debe ingresar el contrato"
      );

      return;

    }

    if (!formData.tipo_cobertura) {

      setError(
        "Debe ingresar tipo cobertura"
      );

      return;

    }

    if (!formData.contratante) {

      setError(
        "Debe ingresar contratante"
      );

      return;

    }

    if (!formData.objeto) {

      setError(
        "Debe ingresar objeto"
      );

      return;

    }

    if (!formData.lugar_ejecucion) {

      setError(
        "Debe ingresar lugar ejecución"
      );

      return;

    }

    if (
      !formData.fecha_inicio ||
      !formData.fecha_fin
    ) {

      setError(
        "Debe seleccionar fechas"
      );

      return;

    }

    try {

      const res = await authFetch(
        ENDPOINTS.update_informacion_general,
        {
          method: "PUT",

          headers: {
            "Content-Type":
              "application/json"
          },

          body: JSON.stringify(formData)

        }
      );

      if (!res.success) {

        setError(res.message);

        return;

      }

      setSuccess(
        "Información actualizada correctamente"
      );

      setTimeout(() => {

        navigate(
          "/session/mod_administrativa/informacion_general/informacion_general"
        );

      }, 1500);

    } catch (error) {

      console.error(error);

      setError("Error del servidor");

    }

  };

  // ======================================
  // LOADING
  // ======================================

  if (loading) {

    return (
      <p>
        Cargando información...
      </p>
    );

  }

  // ======================================
  // RENDER
  // ======================================

  return (

    <div className="p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center m-3">

        <h3>
          Actualizar Información General
        </h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() =>
            navigate(
              "/session/mod_administrativa/informacion_general/informacion_general"
            )
          }
        >
          <i className="bi bi-arrow-left me-1"></i>

          Volver

        </button>

      </div>

      {/* FORM */}

      <form
        className="card p-4 shadow-sm"
        onSubmit={handleSubmit}
      >

        {/* ERROR */}

        {error && (

          <div className="alert alert-danger">

            {error}

          </div>

        )}

        {/* SUCCESS */}

        {success && (

          <div className="alert alert-success">

            {success}

          </div>

        )}

        {/* FILA 1 */}

        <div className="row">

          {/* PROGRAMA */}

          <div className="col-md-6 mb-3">

            <label>
              Programa *
            </label>

            <SearchSelect
              options={programOptions}
              value={formData.programa}
              onChange={(val) =>
                setFormData({
                  ...formData,
                  programa: val
                })
              }
              placeholder="Buscar programa..."
            />

          </div>

          {/* CONTRATO */}

          <div className="col-md-6 mb-3">

            <label>
              Contrato / Convenio *
            </label>

            <input
              type="text"
              name="contrato_convenio"
              className="form-control"
              value={formData.contrato_convenio}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FILA 2 */}

        <div className="row">

          {/* TIPO COBERTURA */}

          <div className="col-md-6 mb-3">

            <label>
              Tipo cobertura *
            </label>

            <input
              type="text"
              name="tipo_cobertura"
              className="form-control"
              value={formData.tipo_cobertura}
              onChange={handleChange}
            />

          </div>

          {/* CONTRATANTE */}

          <div className="col-md-6 mb-3">

            <label>
              Contratante *
            </label>

            <input
              type="text"
              name="contratante"
              className="form-control"
              value={formData.contratante}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* OBJETO */}

        <div className="mb-3">

          <label>
            Objeto *
          </label>

          <textarea
            name="objeto"
            className="form-control"
            rows="4"
            value={formData.objeto}
            onChange={handleChange}
          />

        </div>

        {/* FILA 3 */}

        <div className="row">

          {/* LUGAR */}

          <div className="col-md-6 mb-3">

            <label>
              Lugar ejecución *
            </label>

            <input
              type="text"
              name="lugar_ejecucion"
              className="form-control"
              value={formData.lugar_ejecucion}
              onChange={handleChange}
            />

          </div>

          {/* COBERTURA */}

          <div className="col-md-6 mb-3">

            <label>
              Cobertura *
            </label>

            <input
              type="text"
              name="cobertura"
              className="form-control"
              value={formData.cobertura}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FECHAS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>
              Fecha inicio *
            </label>

            <input
              type="date"
              name="fecha_inicio"
              className="form-control"
              value={formData.fecha_inicio}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>
              Fecha fin *
            </label>

            <input
              type="date"
              name="fecha_fin"
              className="form-control"
              value={formData.fecha_fin}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FILA 4 */}

        <div className="row">

          {/* VALOR */}

          <div className="col-md-6 mb-3">

            <label>
              Valor contrato antes IVA *
            </label>

            <input
              type="number"
              name="valor_contrato_antes_iva"
              className="form-control"
              value={formData.valor_contrato_antes_iva}
              onChange={handleChange}
            />

          </div>

          {/* PLAZO */}

          <div className="col-md-6 mb-3">

            <label>
              Plazo pago *
            </label>

            <input
              type="text"
              name="plazo_pago"
              className="form-control"
              value={formData.plazo_pago}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* BOTÓN */}

        <button
          type="submit"
          className="btn btn-outline-pink w-100 mt-4"
        >
          Actualizar información general
        </button>

      </form>

    </div>

  );

};

export default UpdateInformacionGeneral;